import React from 'react';
import { Column, Label, Text, RowCentered } from '@ydistri/ds';
import { useCurrency } from '../../../../hooks/useCurrency';
import { useAsoConfigurations } from '../useAsoConfigurations';
import { AsoNumericFieldRow } from '../components/AsoNumericFieldRow';
import AsoTooltip from '../../AsoTooltip';

const RouteValueConstraints: React.FC = () => {
  const currency = useCurrency();
  const { config, debouncedHandleChange } = useAsoConfigurations();

  if (!config) return null;

  return (
    <Column $gap="0.5rem">
      <RowCentered $gap="0.25rem">
        <Label>Route value constraints</Label>
        <AsoTooltip tooltipKey="routeValueConstraints" />
      </RowCentered>
      <Text $width="15rem" $italic>
        (will be ignored when empty)
      </Text>
      <AsoNumericFieldRow
        label="Min. Route Value to Merge"
        value={config.routeValueToMerge}
        onChange={v => debouncedHandleChange({ routeValueToMerge: v })}
        postfix={currency}
        tooltipKey="routeValueToMerge"
      />
      <AsoNumericFieldRow
        label="Min. Route Value to Remove"
        value={config.routeValueToRemove}
        onChange={v => debouncedHandleChange({ routeValueToRemove: v })}
        postfix={currency}
        tooltipKey="routeValueToRemove"
      />
    </Column>
  );
};

export default RouteValueConstraints;
